import { useEffect, useState } from "react";
import Product from "../../assets/images/Image 2.png";
import renameimg from "../../assets/images/rename.svg";
import { FormatValueDecimal, CurrencyConvertion, calculateNetPrice, ConvertFromBase } from "../../utils/Validate";
import FetchData, { GetList, GetOne } from "../../providers/dataProvider";
const getOrderProductId = (item) => item?.orderProductId ?? item?.id;
const getQuoteProductId = (item) => item?.quoteProductId ?? item?.id;

const OrderProductList = ({
    values,
    currencyDetail,
    EditOrderQuantity,
    rename,
    renameError,
    setOrderProductCount,
    onRename,
    onRenameBlur,
    onRenameChange,
    onRenameKeyDown,
}) => {
    const [balancedQt, setBalancedQt] = useState([]);
    const [quotationRevision, setQuotationRevision] = useState({
        quotationId: null,
        isRevisionDraft: false,
        hasCompletedRevision: false,
        isLoaded: false,
        error: null,
    });

    const { data: allCurrencies } = FetchData("currency");
    const { data: allDistributors } = FetchData("distributor");
    const orderDistributor = allDistributors?.find((d) => d?.id === values?.distributorId);
    const baseCurrency = allCurrencies?.find((c) => c?.id === orderDistributor?.currencyId);

    const CurrencyConvertion = (amount, rate, currency) =>
        ConvertFromBase(amount, rate, currency, baseCurrency);

    const orderProducts = values?.products || [];
    const balanceProducts = Array.isArray(balancedQt?.data) ? balancedQt.data : [];
    const revisionStateMatchesOrder =
        quotationRevision?.quotationId === values?.quotationId &&
        quotationRevision?.isLoaded;
    const isRevisionDraft = revisionStateMatchesOrder
        ? quotationRevision?.isRevisionDraft
        : values?.isRevisionDraft === true;
    const hasCompletedRevision =
        revisionStateMatchesOrder &&
        !isRevisionDraft &&
        quotationRevision?.hasCompletedRevision;
    const canShowBalanceProducts =
        revisionStateMatchesOrder &&
        !quotationRevision?.error &&
        !isRevisionDraft;
    const productRows = [
        ...orderProducts.map((item) => {
            const balanceMatch = canShowBalanceProducts && balanceProducts.find(
                (b) => getQuoteProductId(b) === getQuoteProductId(item)
            );
            const correctedQuotedQuantity =
                (isRevisionDraft
                    ? item?.quotedQuantity ?? item?.quoteQuantity ?? item?.quantity
                    : balanceMatch?.quotedQuantity ?? item?.quotedQuantity ?? item?.quantity);

            return {
                ...item,
                quotedQuantity: correctedQuotedQuantity,
                ...(hasCompletedRevision && balanceMatch
                    ? {
                        productName: balanceMatch?.productName ?? item?.productName,
                        listPrice: balanceMatch?.listPrice ?? item?.listPrice,
                        margin: balanceMatch?.margin ?? item?.margin,
                        sellingPrice: balanceMatch?.sellingPrice ?? item?.sellingPrice,
                    }
                    : {}),
                __isSavedOrderMark: true,
            };
        }),
        ...(canShowBalanceProducts ? balanceProducts : [])
            .filter((item) => !orderProducts.some((product) => getQuoteProductId(product) === getQuoteProductId(item)))
            .map((item) => ({ ...item, __isSavedOrderMark: false })),
    ];

    useEffect(() => {
        if (!values?.quotationId) {
            setQuotationRevision({
                quotationId: null,
                isRevisionDraft: false,
                hasCompletedRevision: false,
                isLoaded: true,
                error: null,
            });
            setOrderProductCount(0);
            return;
        }
        let isCurrentRequest = true;
        const quotationId = values.quotationId;
        setQuotationRevision({
            quotationId,
            isRevisionDraft: values?.isRevisionDraft === true,
            hasCompletedRevision: false,
            isLoaded: false,
            error: null,
        });
        GetOne("quotation", { id: quotationId }, (response) => {
            if (!isCurrentRequest) return;
            if (response?.message !== "success" || !response?.data) {
                setQuotationRevision({
                    quotationId,
                    isRevisionDraft: values?.isRevisionDraft === true,
                    hasCompletedRevision: false,
                    isLoaded: true,
                    error: "Could not load quotation revision status. Refresh the order and try again.",
                });
                return;
            }

            const quotation = response.data;
            setQuotationRevision({
                quotationId,
                isRevisionDraft: quotation?.isRevisionDraft === true,
                hasCompletedRevision:
                    Number(quotation?.revisionNumber) > 0 ||
                    Boolean(quotation?.revisionCompletedAtUtc),
                isLoaded: true,
                error: null,
            });
        });
        GetList("quotebalance", { id: values?.quotationId }, setBalancedQt);
        return () => {
            isCurrentRequest = false;
        };
    }, [values?.quotationId, values?.isRevisionDraft, setOrderProductCount]);

    useEffect(() => {
        setOrderProductCount(productRows?.length || 0);
    }, [productRows?.length, setOrderProductCount]);

    return (
        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-12 col-sm-12 col-xs-12 center-card order-products-grid-card">
            <div className="card">
                <div className="card-body p-0">
                    <div className="row">
                        <div className="col-12">
                            {quotationRevision?.error && (
                                <div className="alert alert-warning m-3" role="alert">
                                    {quotationRevision.error}
                                </div>
                            )}
                            <div className="table-responsive">
                                <table className="table table-borderless order-products-grid">
                                    <thead>
                                        <tr>
                                            <th>Mark</th>
                                            <th>Model Number</th>
                                            <th>Quote Quantity</th>
                                            <th>Released Quantity</th>
                                            <th>LPO Quantity</th>
                                            <th>List Price</th>
                                            <th>Margin(+) /
                                                <br /> Discount(-)</th>
                                            <th>Net Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productRows?.length > 0 ? productRows?.map((item, index) => {
                                            const isSavedOrderMark = item?.__isSavedOrderMark === true;
                                            const isSavedOrderMarkFalse = item?.__isSavedOrderMark === false;
                                            return (
                                                <tr key={item?.id || index} aria-disabled={!isSavedOrderMark}>
                                                    <td className="product-mark-cell" data-label="Mark">
                                                        <div className="product-mark-main">
                                                            <div className="product-mark-thumb" aria-hidden="true">
                                                                <img src={Product} alt="" />
                                                            </div>

                                                            <span
                                                                className="product-mark-link"
                                                                title={item?.markName}
                                                                role="button"
                                                                tabIndex={0}
                                                                onClick={() => {
                                                                    console.log("Mark clicked:", item);
                                                                    EditOrderQuantity(item);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                        e.preventDefault();
                                                                        EditOrderQuantity(item);
                                                                    }
                                                                }}
                                                            >
                                                                {item?.markName}
                                                            </span>

                                                            <div className="product-mark-actions">
                                                                <button
                                                                    type="button"
                                                                    title="Rename"
                                                                    disabled={!isSavedOrderMark}
                                                                    onClick={() => onRename && onRename(item)}
                                                                >
                                                                    <img src={renameimg} alt="Rename" />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Inline rename input — shown only for the row currently being renamed */}
                                                        {isSavedOrderMark && rename && getOrderProductId(rename) === getOrderProductId(item) && (
                                                            <div className="product-mark-rename-row mt-1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    value={rename?.markName ?? ""}
                                                                    autoFocus
                                                                    onChange={(e) =>
                                                                        onRenameChange && onRenameChange({ ...rename, markName: e.target.value })
                                                                    }
                                                                    onBlur={() => onRenameBlur && onRenameBlur()}
                                                                    onKeyDown={(e) => onRenameKeyDown && onRenameKeyDown(e)}
                                                                />
                                                                {renameError && <p className="form-error">{renameError}</p>}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td data-label="Model number" style={{ textAlign: "left" }}>{item?.productName}</td>
                                                    <td data-label="Quote quantity" style={{ textAlign: "right" }}>{item?.quotedQuantity ?? item?.quoteQuantity}</td>
                                                    <td data-label="Released quantity" style={{ textAlign: "right" }}>{item?.orderedQuantity ?? item?.factoryReleasedQuantity ?? 0}</td>
                                                    <td data-label="LPO quantity" style={{ textAlign: "right" }}> {isSavedOrderMarkFalse ? "0" : (item?.currentOrderQuantity ?? 0)}</td>
                                                    <td data-label="List price" style={{ textAlign: "right" }}>{isSavedOrderMarkFalse ? "0" : FormatValueDecimal(CurrencyConvertion(item?.listPrice, values?.conversionRate, currencyDetail))}</td>
                                                    <td data-label="Margin" style={{ textAlign: "right" }}>{item?.margin}</td>
                                                    <td data-label="Net price" style={{ textAlign: "right" }}>{isSavedOrderMarkFalse ? "0" : FormatValueDecimal(CurrencyConvertion(item?.sellingPrice, values?.conversionRate, currencyDetail))}</td>
                                                </tr>
                                            )
                                        }) : (
                                            <tr>
                                                <td colSpan="9">
                                                    <div className="order-products-empty-state">
                                                        <strong>No marks added yet</strong>
                                                        <span>Select a quotation to load product marks for this order.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion account-summary-accordion my-2" id="orderaccSummaryAccordion">
                                <div className="card account-summary-card">
                                    <div className="card-header" id="headingTwo">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link btn-block text-left account-summary-accordion-toggle"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                <i className="fas fa-file-alt account-summary-accordion-icon" aria-hidden="true"></i>
                                                <span>Account Summary</span>
                                            </button>
                                        </h2>
                                    </div>

                                    <div
                                        id="collapseOne"
                                        className="collapse"
                                        aria-labelledby="headingOne"
                                        data-parent="#orderaccSummaryAccordion"
                                    >
                                        <div className="card-body">
                                            <div className="row account-summary-metrics m-2">
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Credit Limit</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Outstanding</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Overdue</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Pending Orders</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Pending Delivery</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Available Room</label>
                                                    <p>0</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderProductList;
